import * as React from 'react';
import {Route} from 'react-router-dom';

import {appHistory} from '../../../../../../history';

import {colors} from '../../colors/colors';
import {FileIcon} from '../../icon/svg/file-icon';
import {Divider} from '../../layout/divider';

import type {NavItem} from '../types';

import {isSubmenuItemActive} from './helpers';
import {LinkItem} from './link-item';
import {SectionHeader} from './section-header';
import {SectionSubmenu} from './section-submenu';
import {SidebarHeader} from './sidebar-header';

import styles from './sidebar-section.module.css';

type Props = {
    item: NavItem;
};

export function SidebarSection(props: Props) {
    let sectionToReturn = null;

    if (props.item.submenu && !props.item.requiresUpgrade) {
        const submenu = props.item.submenu;

        sectionToReturn = (
            <Route path={props.item.to}>
                {({location}) => {
                    const isSectionOpen = submenu.some((submenuItem) => {
                        return isSubmenuItemActive(submenuItem, location);
                    });

                    return (
                        <>
                            <SectionHeader
                                icon={props.item.icon || FileIcon}
                                // @ts-expect-error
                                submenu={submenu}
                                isOpen={isSectionOpen}
                                // @ts-expect-error
                                onClick={() => appHistory.push(submenu[0].to)}
                                label={props.item.label}
                            />
                            {isSectionOpen && (
                                <SectionSubmenu submenu={submenu} footer={props.item.footer} />
                            )}
                        </>
                    );
                }}
            </Route>
        );
    } else if (props.item.isHeader || props.item.isTopHeader) {
        sectionToReturn = (
            <SidebarHeader label={props.item.label} isTopHeader={props.item.isTopHeader} />
        );
    } else if (props.item.to) {
        sectionToReturn = (
            <LinkItem
                id={typeof props.item.label === 'string' ? props.item.label : props.item.id || ''}
                linkText={props.item.label}
                isBold={props.item.isBold}
                to={props.item.to}
                icon={props.item.icon || FileIcon}
                requiresUpgrade={props.item.requiresUpgrade}
                isExternalLink={props.item.isExternalLink}
                activeMatch={props.item.activeMatch}
                warningTooltip={props.item.warningTooltip}
                count={props.item.count}
                isLegacyIcon={props.item.isLegacyIcon}
            />
        );
    }

    if (props.item.hasDivider) {
        return (
            <>
                {sectionToReturn}
                <div className={styles['divider-wrapper']}>
                    <Divider
                        variant='line--horizontal'
                        spacing={16}
                        color={colors.secondarySidebarHoverBlue}
                    />
                </div>
            </>
        );
    }

    return sectionToReturn;
}
